export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7141.436ae7c6.jpg";